import React from 'react';
import {Button} from 'primereact/button';
import {IEditDataCellProps} from '../../../../utils/cellInterfaces';
import {ConfirmPopup, confirmPopup} from 'primereact/confirmpopup';

import './CustomIconButton.scss'
import {useHasPermissions} from "../../../../../../../hooks/useHasPermissions";

export function EditDataCell(props: IEditDataCellProps) {
    const acceptDelete = () => {
        props.onClickDelete(props.index)
    };

    const acceptCopy = () => {
        props.onClickCopy(props.index)
    }

    const reject = () => {
    };

    const deleteConfirm = (event: any) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this entry?',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: acceptDelete,
            reject
        });
    };

    const copyConfirm = (event: any) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to copy this entry?',
            icon: 'pi pi-copy',
            acceptClassName: 'p-button-success',
            accept: acceptCopy,
            reject
        });
    };

    return <span className={"edit-buttons"} style={{display: "flex", flexWrap: "nowrap", justifyContent: "center", alignItems:"center"}}>
        {props.isInEditMode ? (
            <>
                <div>
                    <Button icon="pi pi-save" className="p-button-rounded p-button-text"
                            onClick={() => props.onClickSave(props.index)}/>
                </div>
                <div>
                    <Button icon="pi pi-times" className="p-button-rounded p-button-text"
                            onClick={() => props.onClickCancel(props.index)}/>
                </div>
            </>
        ) : (
            <>
                <div>
                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-text"
                            onClick={() => props.onClickEdit(props.index)}
                            disabled={!useHasPermissions("easas.product_templates.signature-override")&&!!props.signedBy}
                            tooltip={props.signedBy ? `Entry locked, editing disabled.\nSigned by ${props.signedBy}.` : ""}
                            tooltipOptions={{showOnDisabled: true}}
                    />
                </div>
                <div>
                    <Button icon="pi pi-copy" className="p-button-rounded p-button-text" onClick={copyConfirm}/>
                </div>

            </>
        )
        }
        {props.deletable &&
            <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger"
                    onClick={deleteConfirm}/>
        }
        <ConfirmPopup/>
    </span>

}